var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-dm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#108c00",
    d: "M-258.27 0h1027.5v512h-1027.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M-260 178.16H772.6v50.162H-260z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M181.08 0h48.432v512H181.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.78 0h48.432v512H227.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-260 226.59H772.6v50.162H-260z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-260 276.76H772.6v50.162H-260z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M276.22 0h48.432v512H276.22z"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1)",
    ry: 137.51,
    width: 273.75,
    y: -393.87,
    x: -394.56,
    height: 275.03,
    fill: "#e72910"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.51 136.92c0-.258 5.61-15.997 5.61-15.997l5.098 15.74s17.08.515 17.08.257-13.51 10.32-13.51 10.32 6.373 18.062 6.118 17.546c-.255-.516-14.787-10.837-14.787-10.837s-14.787 10.32-14.532 10.32 5.608-17.03 5.608-17.03l-13.256-10.063 16.57-.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.274 137.72c0-.224 4.857-13.855 4.857-13.855l4.417 13.63s14.794.448 14.794.225-11.7 8.938-11.7 8.938 5.52 15.643 5.298 15.196c-.22-.447-12.807-9.386-12.807-9.386s-12.805 8.94-12.584 8.94 4.857-14.75 4.857-14.75l-11.48-8.716 14.35-.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.328 139.987c0-.13 2.8-7.99 2.8-7.99l2.547 7.86s8.53.26 8.53.13-6.747 5.154-6.747 5.154 3.182 9.02 3.055 8.762c-.127-.257-7.384-5.41-7.384-5.41s-7.385 5.153-7.257 5.153 2.8-8.504 2.8-8.504l-6.62-5.025 8.275-.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.875 211.8c0-.258 5.608-15.997 5.608-15.997l5.1 15.74s17.08.515 17.08.257-13.512 10.32-13.512 10.32 6.375 18.062 6.12 17.546c-.255-.516-14.787-10.837-14.787-10.837s-14.786 10.32-14.53 10.32 5.607-17.03 5.607-17.03l-13.256-10.063 16.57-.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.638 212.6c0-.224 4.857-13.855 4.857-13.855l4.416 13.63s14.795.448 14.795.225-11.702 8.938-11.702 8.938 5.52 15.643 5.3 15.196c-.222-.447-12.808-9.386-12.808-9.386s-12.806 8.94-12.585 8.94 4.857-14.75 4.857-14.75l-11.48-8.716 14.35-.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.692 214.867c0-.13 2.8-7.99 2.8-7.99l2.547 7.86s8.53.26 8.53.13-6.748 5.154-6.748 5.154 3.182 9.02 3.055 8.762c-.127-.257-7.384-5.41-7.384-5.41s-7.384 5.153-7.256 5.153 2.8-8.504 2.8-8.504l-6.62-5.025 8.275-.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.875 330.65c0-.258 5.608-15.997 5.608-15.997l5.1 15.74s17.08.515 17.08.257-13.512 10.32-13.512 10.32 6.375 18.062 6.12 17.546c-.255-.516-14.787-10.837-14.787-10.837S316.697 358 316.953 358s5.607-17.03 5.607-17.03l-13.256-10.063 16.57-.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.638 331.45c0-.224 4.857-13.855 4.857-13.855l4.416 13.63s14.795.448 14.795.225-11.702 8.938-11.702 8.938 5.52 15.643 5.3 15.196c-.222-.447-12.808-9.386-12.808-9.386s-12.806 8.94-12.585 8.94 4.857-14.75 4.857-14.75l-11.48-8.716 14.35-.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.692 333.717c0-.13 2.8-7.99 2.8-7.99l2.547 7.86s8.53.26 8.53.13-6.748 5.154-6.748 5.154 3.182 9.02 3.055 8.762c-.127-.257-7.384-5.41-7.384-5.41s-7.384 5.153-7.256 5.153 2.8-8.504 2.8-8.504l-6.62-5.025 8.275-.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.167 330.65c0-.258 5.608-15.997 5.608-15.997l5.1 15.74s17.08.515 17.08.257-13.512 10.32-13.512 10.32 6.374 18.062 6.12 17.546c-.256-.516-14.788-10.837-14.788-10.837S167.99 358 168.245 358s5.607-17.03 5.607-17.03l-13.256-10.063 16.57-.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93 331.45c0-.224 4.857-13.855 4.857-13.855l4.416 13.63s14.794.448 14.794.225-11.702 8.938-11.702 8.938 5.52 15.643 5.3 15.196c-.222-.447-12.808-9.386-12.808-9.386s-12.806 8.94-12.585 8.94 4.857-14.75 4.857-14.75l-11.482-8.716 14.352-.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.984 333.717c0-.13 2.8-7.99 2.8-7.99l2.547 7.86s8.53.26 8.53.13-6.746 5.154-6.746 5.154 3.182 9.02 3.055 8.762c-.128-.257-7.385-5.41-7.385-5.41s-7.384 5.153-7.256 5.153 2.8-8.504 2.8-8.504l-6.62-5.025 8.274-.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.01 208.74c0-.258 5.608-15.997 5.608-15.997l5.1 15.74s17.08.515 17.08.257-13.512 10.32-13.512 10.32 6.374 18.062 6.12 17.546c-.256-.516-14.788-10.837-14.788-10.837s-14.786 10.32-14.53 10.32 5.607-17.03 5.607-17.03l-13.256-10.063 16.57-.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.773 209.54c0-.224 4.857-13.855 4.857-13.855l4.416 13.63s14.794.448 14.794.225-11.702 8.938-11.702 8.938 5.52 15.643 5.3 15.196c-.222-.447-12.808-9.386-12.808-9.386s-12.806 8.94-12.585 8.94 4.857-14.75 4.857-14.75l-11.48-8.716 14.35-.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.827 211.807c0-.13 2.8-7.99 2.8-7.99l2.547 7.86s8.53.26 8.53.13-6.747 5.154-6.747 5.154 3.182 9.02 3.055 8.762c-.127-.257-7.384-5.41-7.384-5.41s-7.384 5.153-7.256 5.153 2.8-8.504 2.8-8.504l-6.62-5.025 8.275-.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.615 174.14c0 .258-5.608 15.997-5.608 15.997l-5.1-15.74s-17.08-.515-17.08-.257 13.512-10.32 13.512-10.32-6.375-18.062-6.12-17.546c.255.516 14.787 10.837 14.787 10.837s14.786-10.32 14.53-10.32-5.607 17.03-5.607 17.03l13.256 10.063-16.57.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.852 173.34c0 .224-4.857 13.855-4.857 13.855l-4.416-13.63s-14.795-.448-14.795-.225 11.702-8.938 11.702-8.938-5.52-15.643-5.3-15.196c.222.447 12.808 9.386 12.808 9.386s12.806-8.94 12.585-8.94-4.857 14.75-4.857 14.75l11.48 8.716-14.35.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.798 171.073c0 .13-2.8 7.99-2.8 7.99l-2.547-7.86s-8.53-.26-8.53-.13 6.748-5.154 6.748-5.154-3.182-9.02-3.055-8.762c.127.257 7.384 5.41 7.384 5.41s7.384-5.153 7.256-5.153-2.8 8.504-2.8 8.504l6.62 5.025-8.275.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.315 290.28c0 .258-5.608 15.997-5.608 15.997l-5.1-15.74s-17.08-.515-17.08-.257 13.512-10.32 13.512-10.32-6.375-18.062-6.12-17.546c.255.516 14.787 10.837 14.787 10.837s14.786-10.32 14.53-10.32-5.607 17.03-5.607 17.03l13.256 10.063-16.57.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.552 289.48c0 .224-4.857 13.855-4.857 13.855l-4.416-13.63s-14.795-.448-14.795-.225 11.702-8.938 11.702-8.938-5.52-15.643-5.3-15.196c.222.447 12.808 9.386 12.808 9.386s12.806-8.94 12.585-8.94-4.857 14.75-4.857 14.75l11.48 8.716-14.35.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.498 287.213c0 .13-2.8 7.99-2.8 7.99l-2.547-7.86s-8.53-.26-8.53-.13 6.748-5.154 6.748-5.154-3.182-9.02-3.055-8.762c.127.257 7.384 5.41 7.384 5.41s7.384-5.153 7.256-5.153-2.8 8.504-2.8 8.504l6.62 5.025-8.275.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.425 375.25c0 .258-5.608 15.997-5.608 15.997l-5.1-15.74s-17.08-.515-17.08-.257 13.512-10.32 13.512-10.32-6.375-18.062-6.12-17.546c.255.516 14.787 10.837 14.787 10.837s14.786-10.32 14.53-10.32-5.607 17.03-5.607 17.03l13.256 10.063-16.57.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.662 374.45c0 .224-4.857 13.855-4.857 13.855l-4.416-13.63s-14.795-.448-14.795-.225 11.702-8.938 11.702-8.938-5.52-15.643-5.3-15.196c.222.447 12.808 9.386 12.808 9.386s12.806-8.94 12.585-8.94-4.857 14.75-4.857 14.75l11.48 8.716-14.35.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.608 372.183c0 .13-2.8 7.99-2.8 7.99l-2.547-7.86s-8.53-.26-8.53-.13 6.748-5.154 6.748-5.154-3.182-9.02-3.055-8.762c.127.257 7.384 5.41 7.384 5.41s7.384-5.153 7.256-5.153-2.8 8.504-2.8 8.504l6.62 5.025-8.275.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.935 290.28c0 .258-5.608 15.997-5.608 15.997l-5.1-15.74s-17.08-.515-17.08-.257 13.512-10.32 13.512-10.32-6.375-18.062-6.12-17.546c.255.516 14.787 10.837 14.787 10.837s14.786-10.32 14.53-10.32-5.607 17.03-5.607 17.03l13.256 10.063-16.57.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.172 289.48c0 .224-4.857 13.855-4.857 13.855l-4.416-13.63s-14.795-.448-14.795-.225 11.702-8.938 11.702-8.938-5.52-15.643-5.3-15.196c.222.447 12.808 9.386 12.808 9.386s12.806-8.94 12.585-8.94-4.857 14.75-4.857 14.75l11.48 8.716-14.35.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.118 287.213c0 .13-2.8 7.99-2.8 7.99l-2.547-7.86s-8.53-.26-8.53-.13 6.748-5.154 6.748-5.154-3.182-9.02-3.055-8.762c.127.257 7.384 5.41 7.384 5.41s7.384-5.153 7.256-5.153-2.8 8.504-2.8 8.504l6.62 5.025-8.275.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.655 175.85c0 .258-5.608 15.997-5.608 15.997l-5.1-15.74s-17.08-.515-17.08-.257 13.512-10.32 13.512-10.32-6.375-18.062-6.12-17.546c.255.516 14.787 10.837 14.787 10.837s14.786-10.32 14.53-10.32-5.607 17.03-5.607 17.03l13.256 10.063-16.57.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.892 175.05c0 .224-4.857 13.855-4.857 13.855l-4.416-13.63s-14.795-.448-14.795-.225 11.702-8.938 11.702-8.938-5.52-15.643-5.3-15.196c.222.447 12.808 9.386 12.808 9.386s12.806-8.94 12.585-8.94-4.857 14.75-4.857 14.75l11.48 8.716-14.35.223z",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.838 172.783c0 .13-2.8 7.99-2.8 7.99l-2.547-7.86s-8.53-.26-8.53-.13 6.748-5.154 6.748-5.154-3.182-9.02-3.055-8.762c.127.257 7.384 5.41 7.384 5.41s7.384-5.153 7.256-5.153-2.8 8.504-2.8 8.504l6.62 5.025-8.275.13z",
    fill: "#108c00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250.6 359.43) scale(1.036)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.164 -.016 .012 .184 429.84 -215.63)",
    stroke: "#000",
    strokeWidth: 2.5,
    fill: "#009200"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.805,
    ry: 189.82,
    transform: "matrix(1.405 -.006 .008 1 -534.29 263.72)",
    cy: 586.13,
    cx: 680.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.805,
    ry: 189.82,
    transform: "matrix(1.486 -.006 .01 1 -547.22 267.05)",
    cy: 586.13,
    cx: 680.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.805,
    ry: 189.82,
    transform: "matrix(1.19 -.006 .007 1.105 -364.93 214.1)",
    cy: 586.13,
    cx: 680.21
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "translate(72.865 -9.797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.34 971.79c29.972-1.665 16.65-16.652 31.637-24.977 14.986-8.326 36.633-3.33 43.293 6.66 6.66 9.99 1.666 19.982 9.99 19.982 8.327 0 234.56-12.675 242.88-4.35 8.327 8.326 9.992 24.978 1.666 31.635-8.325 6.66-294.5 14.34-304.49 7.68-9.99-6.66-24.977-34.965-24.977-36.63z",
    transform: "matrix(.202 .003 -.004 .214 340.86 -247.31)",
    strokeWidth: 2.505,
    fill: "#a95600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.59 405.46c0 39.983 45.562 27.88 46.81 61.25-.724 35.407-76.706 3.466-78.635-61.25 1.93-64.716 75.107-97.93 76.705-61.01 1.246 30.685-44.88 21.027-44.88 61.01z",
    transform: "matrix(.148 .002 -.003 .115 340.42 -81.69)",
    strokeWidth: 3.853,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.59 405.46c0 39.983 45.562 27.88 46.81 61.25-.724 35.407-76.706 3.466-78.635-61.25 1.93-64.716 75.107-97.93 76.705-61.01 1.246 30.685-44.88 21.027-44.88 61.01z",
    transform: "matrix(.148 .002 -.003 .115 344.42 -81.638)",
    strokeWidth: 3.853,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.59 405.46c0 39.983 45.562 27.88 46.81 61.25-.724 35.407-76.706 3.466-78.635-61.25 1.93-64.716 75.107-97.93 76.705-61.01 1.246 30.685-44.88 21.027-44.88 61.01z",
    transform: "matrix(.148 .002 -.003 .115 348.71 -81.8)",
    strokeWidth: 3.853,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.59 405.46c0 39.983 45.562 27.88 46.81 61.25-.724 35.407-76.706 3.466-78.635-61.25 1.93-64.716 75.107-97.93 76.705-61.01 1.246 30.685-44.88 21.027-44.88 61.01z",
    transform: "matrix(.148 .002 -.003 .115 352.71 -81.747)",
    strokeWidth: 3.853,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.534,
    ry: 3.403,
    transform: "matrix(1.095 .016 -.024 1.154 -75.57 4.678)",
    cy: -41.086,
    cx: 478.38,
    strokeWidth: 0.399,
    fill: "#a95600"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5.8 688.37 -625.218)",
    stroke: "#000",
    strokeWidth: 2.5,
    fill: "#009200"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.166 -.008 .002 .315 369.8 -361.65)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.166 -.008 .002 .315 364.04 -362.7)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.166 -.008 .002 .315 360.64 -370.55)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.01 .002 .348 369.3 -399.35)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 377.41 -379.07)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 373.22 -382.21)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 367.99 -386.66)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 363.01 -389.54)",
    cy: 905,
    cx: 427.11
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.17 346.35s-54.198 64.893-21.252 208.82c33.958 144.59 178.96 189.78 178.96 189.78s26.496-47.423 1.726-164.04c-39.96-169.85-116.14-234.56-116.14-234.56H173.17z",
    transform: "matrix(.177 .032 -.03 .182 461.79 -208.61)",
    stroke: "#000",
    strokeWidth: 2.5,
    fill: "#804bff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(4.47 180.984 769.886)",
    stroke: "#000",
    strokeWidth: 2.5,
    fill: "#009200"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.166 -.008 .002 .315 369.8 -361.65)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.166 -.008 .002 .315 364.04 -362.7)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.166 -.008 .002 .315 360.64 -370.55)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.01 .002 .348 369.3 -399.35)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 377.41 -379.07)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 373.22 -382.21)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 367.99 -386.66)",
    cy: 905,
    cx: 427.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(.16 -.008 .002 .326 363.01 -389.54)",
    cy: 905,
    cx: 427.11
  })), /*#__PURE__*/React.createElement("ellipse", {
    rx: 58.28,
    ry: 186.49,
    stroke: "#000",
    transform: "matrix(.157 -.06 .064 .148 369.61 -145.05)",
    cy: 606.11,
    cx: 624.42,
    strokeWidth: "1pt",
    fill: "#c90000"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "#009200",
    transform: "rotate(1.025 242.403 -1957.802)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.395 0 0 .293 445.07 -230.53)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.464
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .293 457.17 -235.92)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .293 452 -235.92)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.37 0 0 .275 449.48 -233.46)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.37 0 0 .275 448.95 -237.93)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .293 447.01 -238.85)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .287 448.08 -241.58)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.562
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.395 0 0 .293 432.77 -243.48)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.464
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.37 0 0 .275 445.92 -243.48)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .287 444.16 -246.97)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.562
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .293 436.14 -243.17)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .287 437.42 -243.88)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.562
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(.354 0 0 .287 438.99 -247.02)",
    cy: 356.75,
    cx: 218.13,
    strokeWidth: 1.562
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "#009200",
    transform: "matrix(.18 -.005 .004 .185 420.99 -216.8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 67.438,
    ry: 205.64,
    transform: "matrix(.976 -.308 .363 .874 -245.81 324.4)",
    cy: 564.48,
    cx: 528.68,
    strokeWidth: 2.545
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "rotate(-23.382 630.518 660.85)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87 643.99c0 57.677-18.755 86.17-34.55 110.32 7.516-32.47 12.904-52.637 12.904-110.31 0-57.677 29.58-85.337 40.38-101.99-4.187 16.652-18.734 44.312-18.734 101.99z",
    transform: "matrix(1.883 -.456 .953 1.182 -352.26 -10.02)",
    strokeWidth: 1.533
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87 643.99c0 57.677-18.755 86.17-34.55 110.32 7.516-32.47 12.904-52.637 12.904-110.31 0-57.677 29.58-85.337 40.38-101.99-4.187 16.652-18.734 44.312-18.734 101.99z",
    transform: "matrix(1.883 -.456 .953 1.182 -348.42 44.058)",
    strokeWidth: 1.533
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87 643.99c0 57.677-18.755 86.17-34.55 110.32 7.516-32.47 12.904-52.637 12.904-110.31 0-57.677 29.58-85.337 40.38-101.99-4.187 16.652-18.734 44.312-18.734 101.99z",
    transform: "matrix(1.873 -.495 .978 1.162 -361.92 105.78)",
    strokeWidth: 1.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(1.81 -.4 .7 1.635 -915.63 -221.01)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 1.389
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(1.626 -.23 .542 1.353 -739.49 -91.775)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 1.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(1.63 -.197 .513 1.363 -750.62 -91.826)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 1.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(1.314 -.2 .47 1.01 -531.06 47.568)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 2.097
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(1.326 -.13 .403 1.033 -517.87 12.21)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 2.097
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 569.47c0 34.006-6.712 61.61-14.985 61.61-8.272 0-14.986-27.604-14.986-61.61",
    transform: "matrix(1.025 -.493 .464 1.177 12.767 -14.52)",
    strokeWidth: 2.086
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(1.326 -.13 .403 1.033 -519.53 -34.412)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 2.097
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(1.33 -.105 .38 1.04 -533.98 -40.12)",
    cy: 646.07,
    cx: 528.68,
    strokeWidth: 2.097
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 569.47c0 34.006-6.712 61.61-14.985 61.61-8.272 0-14.986-27.604-14.986-61.61",
    transform: "matrix(.672 -.472 .46 .8 39.486 143.28)",
    strokeWidth: 2.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 569.47c0 34.006-6.712 61.61-14.985 61.61-8.272 0-14.986-27.604-14.986-61.61",
    transform: "matrix(.672 -.472 .46 .8 51.142 125.79)",
    strokeWidth: 2.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 569.47c0 34.006-6.712 61.61-14.985 61.61-8.272 0-14.986-27.604-14.986-61.61",
    transform: "matrix(.937 -.645 .64 1.092 -40.198 -10.744)",
    strokeWidth: 2.086
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 569.47c0 34.006-6.712 61.61-14.985 61.61-8.272 0-14.986-27.604-14.986-61.61",
    transform: "matrix(.672 -.52 .46 .88 68.626 71.18)",
    strokeWidth: 2.742
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2.5,
    fill: "#804bff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.27 345.41c-12.278 9.174.41 25.144 12.022 30.68 13.06 7.67 86.603 58.184 136.32 11.998-40.795.833-118.66-63.183-148.34-42.678z",
    transform: "matrix(.156 .007 -.004 .225 457.948 -214.274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.27 345.41c-12.278 9.174.41 25.144 12.022 30.68 13.06 7.67 86.603 58.184 136.32 11.998-40.795.833-118.66-63.183-148.34-42.678z",
    transform: "matrix(.156 .007 -.004 .225 456.55 -220.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.27 345.41c-12.278 9.174.41 25.144 12.022 30.68 13.06 7.67 86.603 58.184 136.32 11.998-40.795.833-118.66-63.183-148.34-42.678z",
    transform: "matrix(.156 .007 -.004 .225 454.775 -225.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.27 345.41c-12.278 9.174.41 25.144 12.022 30.68 13.06 7.67 86.603 58.184 136.32 11.998-40.795.833-118.66-63.183-148.34-42.678z",
    transform: "matrix(.156 .007 -.004 .225 450.905 -232.203)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(1.025 -589.593 681.628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.17 247.3c21.773-12.065 56.618-9.75 79.734 11.165 19.36 16.943 45.307 75.194 70.322 92.834-20.227.018-31.298-5.77-42.24-15.18-28.768 15.44-38.128 16.723-63.89 15.63-35.882-1.333-62.46-17.653-68.18-40.603-6.165-21.804 4.926-52.498 24.254-63.847z",
    transform: "matrix(.21 -.04 .047 .18 407.8 -213.64)",
    stroke: "#000",
    strokeWidth: 2.5,
    fill: "#804bff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.154,
    ry: 14.986,
    stroke: "#000",
    transform: "matrix(.245 0 0 .134 401.82 -215.18)",
    cy: 323.04,
    cx: 287.23,
    strokeWidth: 2.5,
    fill: "red"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 23.254,
    ry: 15.895,
    stroke: "#000",
    transform: "matrix(.194 -.076 .068 .173 398.66 -208.06)",
    cy: 348.26,
    cx: 204.58,
    strokeWidth: 2.5,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.828,
    ry: 5.828,
    transform: "matrix(.214 0 0 .185 411.29 -233.74)",
    cy: 333.86,
    cx: 283.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.8 260.29c4.425 18.107-6.674 43.083-33.133 52.61-26.775 13.172-46.08 41.83-55.64 88.016-47.245-103.27-23.108-148.28 20.6-160.35 37.376-14.363 60.42-13.37 68.173 19.72z",
    transform: "matrix(.092 0 -.003 .085 417.85 -191.49)",
    stroke: "#000",
    strokeWidth: 6.56,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.71,
    ry: 4.71,
    transform: "matrix(.187 -.013 .014 .19 418.69 -234.98)",
    cy: 362.39,
    cx: 198.98
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.89e9bc15570e32aaf58d7fc334f36b71.svg";
export { ForwardRef as ReactComponent };